import React from 'react';
import { useDispatch as useDispatchReact } from 'react-redux';

export const useDispatch = action => {
  const dispatch = useDispatchReact();
  return React.useCallback((...args) => dispatch(action(...args)), [action, dispatch]);
};
